import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import AutoInspect from '../AutoInspect';
import AutoInspectResults from './AutoInspectResults';
import ClickImagesView from './ClickImagesView';
import HintsPanel from '../HintsPanel';

const InspectionPanel = ({ appInfo, runId = null, viewConfig = {} }) => {
  const showViolations = !!viewConfig?.violationsSection;
  const showClickImages = !!viewConfig?.clickImagesSection;

  const tabs = [];
  if (showClickImages) tabs.push({ key: 'clickImages', label: 'Click Images' });
  if (showViolations) tabs.push({ key: 'violations', label: 'Violations' });
  tabs.push({ key: 'acrs', label: 'ACRs' });

  const [activeTab, setActiveTab] = useState(0);
  const currentKey = tabs[activeTab]?.key;

  return (
    <Box display="flex" flexDirection="column" sx={{ height: '100%', minHeight: 0, overflow: 'hidden' }}>
      {/* Tab bar with action buttons on the right */}
      <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', borderBottom: 1, borderColor: 'divider', pr: 5 }}>
        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
        >
          {tabs.map((t) => <Tab key={t.key} label={t.label} />)}
        </Tabs>
        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <AutoInspect appInfo={appInfo} />
        </Box>
      </Box>

      {/* Tab content — all mounted, inactive hidden to preserve state */}
      {showClickImages && (
        <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0, display: currentKey === 'clickImages' ? 'flex' : 'none', flexDirection: 'column' }}>
          <ClickImagesView appInfo={appInfo} runId={runId} viewConfig={viewConfig} />
        </Box>
      )}
      {showViolations && (
        <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0, display: currentKey === 'violations' ? 'flex' : 'none', flexDirection: 'column' }}>
          <AutoInspectResults appInfo={appInfo} runId={runId} viewConfig={viewConfig} inline />
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0, display: currentKey === 'acrs' ? 'flex' : 'none', flexDirection: 'column' }}>
        <HintsPanel inline />
      </Box>
    </Box>
  );
};

export default InspectionPanel;
